var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"invitee"},[_vm._v(" 更多好菜，尽在舌尖英雄 ")])
}
var staticRenderFns = []

export { render, staticRenderFns }